import { Panel } from "primereact/panel";
import { RestricaoFullResumo } from "./RestricaoFullResumo";

export default function RestricaoFullPF({ restricaoFullPf }: { restricaoFullPf: any }) {
  const cadastrais = restricaoFullPf?.dados_cadastrais;

  return (
    <div>
      {restricaoFullPf?.mensagemErro ? (<p>{restricaoFullPf.mensagemErro}</p>) : (<>
        {cadastrais && (
          <div>
            <br />
            <Panel header="Dados Cadastrais">
              <div className="flex-consulta flex-wrap gap-3">
                <div><b>CPF:</b> {cadastrais.cpf}</div>
                <div><b>Nome:</b> {cadastrais.nome}</div>
                <div><b>Nascimento:</b> {cadastrais.data_nascimento}</div>
                <div><b>Nome da Mãe:</b> {cadastrais.nome_mae}</div>
                <div><b>Situação:</b> {cadastrais.situacao}</div>
                {cadastrais.data_situacao && (<div><b>Dt. Situação:</b> {cadastrais.data_situacao}</div>)}
              </div>
            </Panel>
          </div>
        )}
        <RestricaoFullResumo dados={restricaoFullPf} />
      </>)}
    </div>
  );
}
